/* eslint-disable func-names */
import { object, string } from 'yup';

export const dadosContatoSchema = object({
  id: string(),
  email: string()
    .email('Favor inserir um email válido')
    .required('O email é obrigatório'),
  celular: string()
    .test(
      'validar-celular',
      'Favor inserir um celular válido',
      function (value) {
        const celularFormatado = (value || '').replace(/\D/g, '');
        return celularFormatado.length === 11 || celularFormatado.length === 0;
      }
    )
    .test(
      'celular-ou-telefone',
      'É necessario o cadastro de ao menos um número de contato',
      function (value) {
        const { telefoneFixo } = this.parent;
        const telefoneFixoFormatado = (telefoneFixo || '').replace(/\D/g, '');
        const celularFormatado = (value || '').replace(/\D/g, '');
        return celularFormatado || telefoneFixoFormatado;
      }
    ),
  telefoneFixo: string()
    .test(
      'validar-telefone',
      'Favor inserir um telefone fixo válido',
      function (value) {
        const telefoneFixoFormatado = (value || '').replace(/\D/g, '');
        return (
          telefoneFixoFormatado.length === 10 ||
          telefoneFixoFormatado.length === 0
        );
      }
    )
    .test(
      'telefone-ou-celular',
      'É necessario o cadastro de ao menos um número de contato',
      function (value) {
        const { celular } = this.parent;
        const celularFormatado = (celular || '').replace(/\D/g, '');
        const telefoneFixoFormatado = (value || '').replace(/\D/g, '');
        return telefoneFixoFormatado || celularFormatado;
      }
    ),
});

export class DadosContatoModel {
  id = '';

  email = '';

  celular = '';

  telefoneFixo = '';
}
